import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * @returns {Array}
 */
export const useElementWidth = () => {
  const [width, setWidth] = useState(0);
  const resizeObserverRef = useRef(null);
  const rafIdRef = useRef(null);

  const cancelPendingFrame = useCallback(() => {
    if (rafIdRef.current != null) {
      cancelAnimationFrame(rafIdRef.current);
      rafIdRef.current = null;
    }
  }, []);

  const ref = useCallback(
    node => {
      cancelPendingFrame();

      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
        resizeObserverRef.current = null;
      }

      if (node && typeof ResizeObserver !== 'undefined') {
        resizeObserverRef.current = new ResizeObserver(entries => {
          cancelPendingFrame();
          rafIdRef.current = window.requestAnimationFrame(() => {
            rafIdRef.current = null;
            if (entries[0]) {
              setWidth(entries[0].contentRect.width);
            }
          });
        });
        resizeObserverRef.current.observe(node);
      }
    },
    [cancelPendingFrame]
  );

  useEffect(() => {
    return () => {
      cancelPendingFrame();
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
        resizeObserverRef.current = null;
      }
    };
  }, [cancelPendingFrame]);

  return { ref, width };
};
